import "../../../FhButtonBase.css";
import { computed, openBlock, createBlock, resolveDynamicComponent, mergeProps, withCtx, renderSlot, createCommentVNode } from "vue";
import { isExternalURL } from "../../../utils/url.mjs";
import FhSpinner from "../../FhSpinner/FhSpinner.mjs";
import { _ as _export_sfc } from "../../../_plugin-vue_export-helper-1tPrXgE0.js";
const _sfc_main = /* @__PURE__ */ Object.assign({
  inheritAttrs: false
}, {
  __name: "FhButtonBase",
  props: {
    variant: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    href: {
      type: String,
      default: ""
    }
  },
  emits: ["click"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const tag = computed(() => props.href ? "a" : "button");
    const type = computed(() => tag.value === "button" ? "button" : null);
    const href = computed(
      () => !props.disabled && props.href ? props.href : null
    );
    const isExternalLink = computed(() => isExternalURL(props.href));
    const linkTarget = computed(() => isExternalLink.value ? "_blank" : null);
    const linkRel = computed(() => isExternalLink.value ? "noreferrer" : null);
    const computedButtonClasses = computed(() => {
      return [
        "fh-button",
        `fh-button--${props.variant}`,
        props.selected && "fh-button--selected",
        props.loading && "fh-button--loading"
      ];
    });
    const computedSpinnerVariant = computed(() => {
      return !props.disabled && (props.variant === "primary" || props.variant === "destructive" || props.variant === "secondary-inverted" || props.variant === "plain-inverted") ? "inverted" : "default";
    });
    const emit = __emit;
    const handleClick = (event) => {
      if (!props.loading) {
        emit("click", event);
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(tag.value), mergeProps({
        type: type.value,
        href: href.value,
        class: computedButtonClasses.value,
        disabled: props.disabled,
        target: linkTarget.value,
        rel: linkRel.value,
        "aria-pressed": props.selected,
        onClick: handleClick
      }, _ctx.$attrs), {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default", {}, void 0, true),
          props.loading ? (openBlock(), createBlock(FhSpinner, {
            key: 0,
            size: "sm",
            variant: computedSpinnerVariant.value
          }, null, 8, ["variant"])) : createCommentVNode("", true)
        ]),
        _: 3
      }, 16, ["type", "href", "class", "disabled", "target", "rel", "aria-pressed"]);
    };
  }
});
const FhButtonBase = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-aa96373e"]]);
export {
  FhButtonBase as default
};
//# sourceMappingURL=FhButtonBase.mjs.map
